/**
 * Datetime helpers for form inputs.
 */

/**
 * Current local time as a `YYYY-MM-DDTHH:mm` string suitable for the `value`
 * or `min` of an `<input type="datetime-local">`.
 *
 * A datetime-local input expects local wall-clock time (no timezone), so we
 * shift the UTC timestamp by the local offset before formatting. Seconds are
 * zeroed to match the minute granularity of the control. Used as `min` to stop
 * past times from being picked (e.g. scheduling a meeting in the past — BUG-005).
 *
 * @param {Date} [date=new Date()] - Reference instant (injectable for tests).
 * @returns {string} Local datetime in `YYYY-MM-DDTHH:mm` format.
 */
export function nowLocalDateTime(date = new Date()) {
  const local = new Date(date.getTime());
  local.setSeconds(0, 0);
  const offsetMs = local.getTimezoneOffset() * 60000;
  return new Date(local.getTime() - offsetMs).toISOString().slice(0, 16);
}
